import '.e8{font-size:1.125rem;}.ssr-plugin'
import '.em{line-height:1.75rem;}.ssr-plugin'
import '.i8{text-decoration:none;}.ssr-plugin'
import '.fx{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e8 em"
    >
      {translations.privacySubtitle}{' '}
      <a className="i8 fx"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i8 fx"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
